// extracted by mini-css-extract-plugin
module.exports = {"link":"_3VzVf","root":"_3zInH","label":"N-Mu4"};